import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import TrialBalanceFilter from "./TrailBalanceFilter";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const useEnhancedEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

const processData = (data) => {
  const flattenedData = [];
  const flattenRowRecursive = (row, parentPath, parentType) => {
    const dataPath = [...parentPath, row.accountName];
    const dataType = [...parentType, row.accountType];
    flattenedData.push({ ...row, dataPath, dataType });
    if (row.childList) {
      row.childList.forEach((children) =>
        flattenRowRecursive(children, dataPath, dataType)
      );
    }
  };
  data.forEach((row) => flattenRowRecursive(row, [], []));
  return flattenedData;
};

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  "&.MuiCheckbox-root.Mui-checked": {
    color: "#ffa726",
  },
}));

const ColorGrid = styled(Box)(({ theme }) => ({
  "& .rag-head-outer": {
    backgroundColor: "#1F252A",
  },
  "& .rag-group-outer": {
    backgroundColor: "#252B31",
  },
  "& .rag-general-ledger-outer": {
    backgroundColor: "#353C44",
  },
  "& .rag-ledger-outer": {
    backgroundColor: "#3D4853",
  },
  "& .rag-sub-ledger-outer": {
    backgroundColor: "#404D5A",
  },
}));

const TrialBalance = () => {
  const [rowData, setRowData] = useState([]);
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const [filterData, setFilterData] = useState({
    companyCode: "",
    prevStartDate: "",
    prevEndDate: "",
    startDate: "",
    endDate: "",
    currency: "",
  });
  const [filterDataTotal, setFilterDataTotal] = useState({
    accountNo: "",
    grandTotalOpeningBalanceDebit: "",
    grandTotalOpeningBalanceCredit: "",
    grandTotalClosingBalanceDebit: "",
    grandTotalClosingBalanceCredit: "",
    grandTotalPrevTransaionDebit: "",
    grandTotalPrevTransaionCredit: "",
    grandTotalTransaionDebit: "",
    grandTotalTransaionCredit: "",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [previousPeriod, setPreviousPeriod] = useState();
  const [masterPeriod, setMasterPeriod] = useState();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [currency, setCurrency] = useState("");
  const [error, setError] = useState("");

  const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.trialBalance}`;

  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // const handleSearchData = async () => {
  //     try {
  //         const list = await OAuthService.getList(url + `/getStatementOfAccount?ledgerId=1&startLoadingDate=${loadingDate}&toLoadingDate=${period}&cutoffDate=${cutoffDate}`);
  //         setRowData(list.data);
  //     } catch (error) {
  //         setError(error.message);
  //     }
  // };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "TrialBalance.xlsx",
      sheetName: "Trial Balance",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  // const prevPeriodCols = (filterData.prevStartDate !== '' && filterData.prevEndDate !== '') || (filterData.prevStartDate !== '' || filterData.prevEndDate !== '') ?  : '';

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "accountNo",
      headerName: "Account No.",
      minWidth: 300,
      maxWidth: 300,
    },
    // { field: "accountName", enableRowGroup: true, headerName: "Account Name", },
    {
      headerName: "Opening Balance",
      children: [
        {
          field: "openingDebit",
          headerName: "Debit",
          minWidth: 160,
          maxWidth: 160,
        },
        {
          field: "openingCredit",
          headerName: "Credit",
          minWidth: 160,
          maxWidth: 160,
        },
      ],
    },
    {
      headerName: "Master Period",
      children: [
        {
          field: "transactionDebit",
          headerName: "Debit",
          minWidth: 160,
          maxWidth: 160,
        },
        {
          field: "transactionCredit",
          headerName: "Credit",
          minWidth: 160,
          maxWidth: 160,
        },
      ],
    },
    {
      headerName: "Closing Balance",
      children: [
        {
          field: "closingDebit",
          headerName: "Debit",
          minWidth: 160,
          maxWidth: 160,
        },
        {
          field: "closingCredit",
          headerName: "Credit",
          minWidth: 160,
          maxWidth: 160,
        },
      ],
    },
  ]);

  useEffect(() => {
    setColumnDefs(
      (filterData.prevStartDate !== "" && filterData.prevEndDate !== "") ||
        filterData.prevStartDate !== "" ||
        filterData.prevEndDate !== ""
        ? [
            {
              field: "accountNo",
              headerName: "Account No.",
              minWidth: 300,
              maxWidth: 300,
            },
            // { field: "accountName", enableRowGroup: true, headerName: "Account Name", },
            {
              headerName: "Opening Balance",
              children: [
                {
                  field: "openingDebit",
                  headerName: "Debit",
                  minWidth: 160,
                  maxWidth: 160,
                },
                {
                  field: "openingCredit",
                  headerName: "Credit",
                  minWidth: 160,
                  maxWidth: 160,
                },
              ],
            },
            {
              headerName: "Previous Period",
              children: [
                {
                  field: "transactionDebitPrev",
                  headerName: "Debit",
                  minWidth: 160,
                  maxWidth: 160,
                },
                {
                  field: "transactionCreditPrev",
                  headerName: "Credit",
                  minWidth: 160,
                  maxWidth: 160,
                },
              ],
            },
            {
              headerName: "Master Period",
              children: [
                {
                  field: "transactionDebit",
                  headerName: "Debit",
                  minWidth: 160,
                  maxWidth: 160,
                },
                {
                  field: "transactionCredit",
                  headerName: "Credit",
                  minWidth: 160,
                  maxWidth: 160,
                },
              ],
            },
            {
              headerName: "Closing Balance",
              children: [
                {
                  field: "closingDebit",
                  headerName: "Debit",
                  minWidth: 160,
                  maxWidth: 160,
                },
                {
                  field: "closingCredit",
                  headerName: "Credit",
                  minWidth: 160,
                  maxWidth: 160,
                },
              ],
            },
          ]
        : columnDefs
    );
  }, [filterData]);

  const autoGroupColumnDef = useMemo(() => {
    return {
      // headerName: "Account Name",
      // field: "accountName",
      //filter: "agSetColumnFilter",
      cellRendererParams: {
        suppressCount: true,
      },
      // minWidth: 0,
      // maxWidth: 0,
    };
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      floatingFilter: true,
      sortable: true,
      resizable: true,
      filter: "agMultiColumnFilter",
    };
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.expandAll();
  }, []);

  const getDataPath = useMemo(() => {
    return (data) => data.dataPath;
  }, []);

  const getRowId = useMemo(() => {
    return (params) => params.data.accountNo;
  }, []);

  const rowClassRules = {
    "rag-head-outer": function (params) {
      return params?.data?.accountType === "HEAD";
    },
    "rag-group-outer": function (params) {
      return params?.data?.accountType === "GROUP";
    },
    "rag-general-ledger-outer": function (params) {
      return params?.data?.accountType === "GENERAL_LEDGER";
    },
    "rag-ledger-outer": function (params) {
      return params?.data?.accountType === "LEDGER";
    },
    "rag-sub-ledger-outer": function (params) {
      return params?.data?.accountType === "SUB_LEDGER";
    },
  };

  const handleSearchCompany = useCallback((year) => {
    var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
    countryFilterComponent.setModel({ values: [year] });
    gridRef.current.api.onFilterChanged();
  }, []);

  // const handleSearch = useCallback((value) => {
  //     gridRef.current.api.setQuickFilter(value);
  // }, []);

  const handleChange = async (e, checkbox) => {
    if (checkbox === "currency") {
      setFilterData((prevValues) => ({
        ...prevValues,
        ["currency"]: e.value,
      }));
    } else if (checkbox === "company") {
      setFilterData((prevValues) => ({
        ...prevValues,
        ["companyCode"]: e.value,
      }));
    } else if (checkbox === "startDate") {
      if (e < filterData.prevEndDate) {
        setError("prevEndDate");
      } else {
        setError("");
      }
      setFilterData((prevValues) => ({
        ...prevValues,
        ["startDate"]: e,
      }));
    } else if (checkbox === "endDate") {
      setFilterData((prevValues) => ({
        ...prevValues,
        ["endDate"]: e,
      }));
    } else if (checkbox === "prevStartDate") {
      setFilterData((prevValues) => ({
        ...prevValues,
        ["prevStartDate"]: e,
      }));
    } else if (checkbox === "prevEndDate") {
      if (filterData.startDate !== "") {
        if (filterData.startDate < e) {
          setError("prevEndDate");
        } else {
          setError("");
        }
      }
      setFilterData((prevValues) => ({
        ...prevValues,
        ["prevEndDate"]: e,
      }));
    } else {
      const name = e.target.name;
      const value = e.target.value;
      if (checkbox === "checkbox") {
        const checked = e.target.checked;
        if (checked) {
          setFilterOptions((prevValues) => ({
            ...prevValues,
            [name]: true,
          }));
        } else {
          setFilterOptions((prevValues) => ({
            ...prevValues,
            [name]: false,
          }));
        }
      }
    }
  };

  const handleSearchData = async () => {
    if (filterData.startDate === "") {
      setError("masterFrom");
    } else if (filterData.endDate === "") {
      setError("masterTo");
    } else {
      try {
        const list = await OAuthService.getPostList(
          url + "/generateTrialBalance",
          filterData
        );
        setRowData(processData(list.data));
        setTrialBalanceData(processData(list.data));

        list.data.slice(-1).map((bal) => {
          console.log("bal ===> ", bal);
          setFilterDataTotal((prevValues) => ({
            ...prevValues,
            ["accountNo"] : "Grand Total : ",
            ["grandTotalOpeningBalanceDebit"]:
              bal.grandTotalOpeningBalanceDebit,
            ["grandTotalOpeningBalanceCredit"]:
              bal.grandTotalOpeningBalanceCredit,
            ["grandTotalClosingBalanceDebit"]:
              bal.grandTotalClosingBalanceDebit,
            ["grandTotalClosingBalanceCredit"]:
              bal.grandTotalClosingBalanceCredit,
            ["grandTotalPrevTransaionDebit"]: bal.grandTotalPrevTransaionDebit,
            ["grandTotalPrevTransaionCredit"]:
              bal.grandTotalPrevTransaionCredit,
            ["grandTotalTransaionDebit"]: bal.grandTotalTransaionDebit,
            ["grandTotalTransaionCredit"]: bal.grandTotalTransaionCredit,
          }));
        });
      } catch (error) {
        setError(error.message);
      }
    }
  };

  const [filterOptions, setFilterOptions] = useState({
    all: true,
    generalLedger: true,
    ledger: true,
    subLedger: true,
    group: true,
    head: true,
  });

  const filterDataBasedOnSelection = (data) => {
    const filteredData = [];
    const { generalLedger, ledger, subLedger, group, head } = filterOptions;

    const shouldInclude = (accountType) => {
      if (generalLedger && accountType === "GENERAL_LEDGER") return true;
      if (ledger && accountType === "LEDGER") return true;
      if (subLedger && accountType === "SUB_LEDGER") return true;
      if (group && accountType === "GROUP") return true;
      if (head && accountType === "HEAD") return true;
      return false;
    };

    const filterRecursive = (item) => {
      if (shouldInclude(item.accountType)) {
        filteredData.push(item);
      }
      if (item.childList && item.childList.length > 0) {
        item.childList.forEach((child) => filterRecursive(child));
      }
    };

    data.forEach((item) => filterRecursive(item));
    return filteredData;
  };

  useEffect(() => {
    const filteredData = filterDataBasedOnSelection(trialBalanceData);
    setRowData(filteredData);
  }, [filterOptions, trialBalanceData]);

  const onBtPrint = useCallback(() => {
    const api = gridRef.current.api;
    setPrinterFriendly(api);
    setTimeout(function () {
      print();
      setNormal(api);
    }, 2000);
  }, [print]);

  const setPrinterFriendly = (api) => {
    const eGridDiv = document.getElementById("chartOfAccountGrid");
    eGridDiv.style.width = "";
    eGridDiv.style.height = "";
    api.setDomLayout("print");
  };

  function setNormal(api) {
    const eGridDiv = document.getElementById("chartOfAccountGrid");
    // eGridDiv.style.width = '700px';
    eGridDiv.style.height = "200px";

    api.setDomLayout();
  }

  const onRowDoubleClicked = (params) => {
    handleEditRowDialogOpen(params);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const [isFullScreen, setIsFullScreen] = useState(false);
  const elementGridRef = useRef(null);

  useEnhancedEffect(() => {
    document.onfullscreenchange = () =>
      setIsFullScreen(document[getBrowserFullscreenElementProp()] != null);

    return () => {
      document.onfullscreenchange = undefined;
    };
  });

  function getBrowserFullscreenElementProp() {
    if (typeof document.fullscreenElement !== "undefined") {
      return "fullscreenElement";
    }
    if (typeof document.mozFullScreenElement !== "undefined") {
      return "mozFullScreenElement";
    }
    if (typeof document.msFullscreenElement !== "undefined") {
      return "msFullscreenElement";
    }
    if (typeof document.webkitFullscreenElement !== "undefined") {
      return "webkitFullscreenElement";
    }
    throw new Error("fullscreenElement is not supported by this browser");
  }

  /* View in fullscreen */
  function openFullscreen() {
    // const elem = document.documentElement;
    const elem = elementGridRef;

    if (elem.current.requestFullscreen) {
      elem.current.requestFullscreen();
    } else if (elem.current.mozRequestFullScreen) {
      /* Firefox */
      elem.current.mozRequestFullScreen();
    } else if (elem.current.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.current.webkitRequestFullscreen();
    } else if (elem.current.msRequestFullscreen) {
      /* IE/Edge */
      elem.current.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
  }

  function toggleFullScreen() {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement
    ) {
      closeFullscreen();
    } else {
      openFullscreen();
    }
  }

  const createRowData = () => {
    const dataObj = {
      accountNo: filterDataTotal.accountNo,
      openingDebit: filterDataTotal.grandTotalOpeningBalanceDebit,
      openingCredit: filterDataTotal.grandTotalOpeningBalanceCredit,
      transactionDebit: filterDataTotal.grandTotalTransaionDebit,
      transactionCredit: filterDataTotal.grandTotalTransaionCredit,
      closingDebit: filterDataTotal.grandTotalClosingBalanceDebit,
      closingCredit: filterDataTotal.grandTotalClosingBalanceCredit,
    };
    if (filterData.prevStartDate && filterData.prevEndDate) {
      dataObj.transactionDebitPrev =
        filterDataTotal.grandTotalPrevTransaionDebit;
      dataObj.transactionCreditPrev =
        filterDataTotal.grandTotalPrevTransaionCredit;
    }
    return [{ ...dataObj }];
  };

  return (
    <>
      <ListPageHeader
        componentName="Trial Balance"
        onBtExport={onBtExport}
        pageName="Trial Balance"
        gridRef={gridRef}
        showPaginationDropdown={showPaginationDropdown}
        onBtPrint={onBtPrint}
      />
      <div className="px-20 pb-4 pt-16">
        <Accordion defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ justifyContent: "center" }}
            className={"justify-center"}
          >
            <Typography className="w-full text-center text-xl">
              Select Fields
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="px-20 pb-16 pt-16">
              <TrialBalanceFilter
                handleChange={handleChange}
                handleSearch={handleSearchData}
                toggleFullScreen={toggleFullScreen}
                setFilterData={setFilterData}
                error={error}
              />
            </div>
            <div className="px-20 pb-16">
              <FormGroup row={true}>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="all"
                      checked={filterOptions.all}
                      value="all"
                      onChange={(e) => handleChange(e, "checkbox")}
                      disabled
                    />
                  }
                  label="All"
                />
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="head"
                      checked={filterOptions.head}
                      value="head"
                      onChange={(e) => handleChange(e, "checkbox")}
                    />
                  }
                  label="Head A/C"
                />
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="group"
                      checked={filterOptions.group}
                      value="group"
                      onChange={(e) => handleChange(e, "checkbox")}
                    />
                  }
                  label="Group"
                />
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="generalLedger"
                      checked={filterOptions.generalLedger}
                      value="generalLedger"
                      onChange={(e) => handleChange(e, "checkbox")}
                    />
                  }
                  label="General Ledger"
                />
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="ledger"
                      checked={filterOptions.ledger}
                      value="ledger"
                      onChange={(e) => handleChange(e, "checkbox")}
                    />
                  }
                  label="Ledger"
                />
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      name="subLedger"
                      checked={filterOptions.subLedger}
                      value="subLedger"
                      onChange={(e) => handleChange(e, "checkbox")}
                    />
                  }
                  label="Sub Ledger"
                />
              </FormGroup>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      <ColorGrid
        id="chartOfAccountGrid"
        className="h-full pr-24 pl-24 ag-theme-alpine-dark grid"
      >
        <AgGridReact
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          ref={gridRef}
          onGridReady={onGridReady}
          autoGroupColumnDef={autoGroupColumnDef}
          groupDefaultExpanded={-1}
          rowData={rowData}
          // tableClassName={"border border-slate-400"}
          editable={false}
          pagination={false}
          treeData={true}
          animateRows={true}
          getDataPath={getDataPath}
          // getRowId={getRowId}
          rowClassRules={rowClassRules}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          showSidebar={true}
          headerHeight={28}
          rowHeight={22}
          onFirstDataRendered={onFirstDataRendered}
          // rowGroupPanelShow={'hide'}
          pinnedBottomRowData={rowData ? createRowData() : []}
          getRowStyle={(params) => {
            if (params.node.rowPinned) {
              return { fontWeight: "bold" };
            }
          }}
        />
      </ColorGrid>
    </>
  );
};

export default TrialBalance;
